import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { context } from "../../context/authContext";
import Dropdown from "react-bootstrap/Dropdown";
import "./Navigation.css";

export default function Navigation() {
    const [menuLeft, setMenuLeft] = useState(false);
    const { handleLogout } = useContext(context);

    const handleOpenMenu = () => setMenuLeft(true);
    const handleCloseMenu = () => setMenuLeft(false);

    return (
        <header>
            <nav className="navbar navbar-light navbar-bg-dark d-flex justify-content-between">
                <button className="btn btn-outline-grey" onClick={handleOpenMenu}>
                    <i className="fas fa-bars"></i> Menú
                </button>
                <div className="logo">
                    <Link to="/dashboard"><img src='../../../img/logo-kloudlab-v01.png' alt="" /></Link>
                </div>
                <Dropdown>
                    <Dropdown.Toggle variant="outline-grey">
                        {localStorage.getItem("email") || "Usuario"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={handleLogout}>Cerrar Sesión</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </nav>

            {
                menuLeft && (
                    <div className="collapse-menu">
                        <div className="collapse-menu-content">
                            <div className="close">
                                <button onClick={handleCloseMenu}>
                                    <i className="fas fa-times mr-1"></i> <b>Cerrar menú</b>
                                </button>
                            </div>
                            <ul className="content">
                                <li>
                                    <Link to="/dashboard" onClick={handleCloseMenu}>
                                        Dashboard
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/api/v1/api-docs" target="_blank" onClick={handleCloseMenu}>
                                        Docs
                                    </Link>
                                </li>
                            </ul>
                            <a href="https://kloudlab.ar" target="_blank" rel="noreferrer"><span className="ps-3 pb-3 text-white">Powered by Kloudlab</span></a>
                        </div>
                    </div>
                )
            }
        </header>
    );
}
